import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class ApplicationVersionsService extends RestfulService<Models.ApplicationVersion> {

  constructor(public restService: RestService) {
    super(Models.ApplicationVersion);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('application-versions');
  }

}
